class WishlistProduct extends HTMLElement {
  constructor() {
    super();
    this.LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
    this.LOCAL_STORAGE_DELIMITER = ",";
    this.BUTTON_ACTIVE_CLASS = "active";
    this.addEventListener("click", this.onAddWishlist.bind(this));
    this.onAddActiveClass();
    this.WishlistItemCounter();
  }

  WishlistItemCounter() {
    const WISHLIST_ITEM_COUNT = document.querySelectorAll(".wishlist__count");
    const count = WishlistProduct.getStoredWishlist().length;
    WISHLIST_ITEM_COUNT.forEach((singleItem) => {
      singleItem.textContent = count;
    });
  }

  onAddActiveClass() {
    const wishlistAddedButton = this.querySelector("button");
    if (wishlistAddedButton) {
      const productHandle = wishlistAddedButton.dataset.productHandle;
      if (!productHandle) return;
      if (this.wishlistContains(productHandle)) {
        wishlistAddedButton.classList.add(this.BUTTON_ACTIVE_CLASS);
      }
    }
  }

  onAddWishlist() {
    const wishlistItem = this.querySelector("button");
    if (!wishlistItem) return;
    const productHandle = wishlistItem.dataset.productHandle;
    if (!productHandle) {
      console.warn("[Wishlist] Missing `data-product-handle` attribute.");
      return;
    }

    this.updateWishlist(productHandle);
    this.WishlistItemCounter();

    const grid = document.querySelector("[grid-wishlist]");

    if (grid) {
      const card = this.closest(".product__card") || this.closest(".product-grid-item");
      if (card) card.remove();
    } else {
      wishlistItem.classList.add("loading", "adding");
      setTimeout(() => {
        wishlistItem.classList.remove("loading");
        wishlistItem.classList.toggle("active");
      }, 500);

      setTimeout(() => {
        const adding = document.querySelector(".adding");
        if (adding) adding.classList.remove("adding");
      }, 1000);
    }

    const currentCount = WishlistProduct.getStoredWishlist().length;
    if (currentCount <= 0 && grid && grid.parentElement) {
      grid.parentElement.classList.remove("wishlist_exists");
      const pageEl = document.querySelector(".wishlist-page");
      if (pageEl) pageEl.classList.remove("wishlist_exists");
    }
  }

  static getStoredWishlist() {
    try {
      const wishlist = localStorage.getItem("shopify-wishlist");
      if (wishlist) return wishlist.split(",").filter(Boolean);
    } catch (e) {}
    return [];
  }

  static setStoredWishlist(array) {
    try {
      const clean = array.filter(Boolean);
      if (clean.length) {
        localStorage.setItem("shopify-wishlist", clean.join(","));
      } else {
        localStorage.removeItem("shopify-wishlist");
      }
    } catch (e) {}
  }

  getWishlist() {
    return WishlistProduct.getStoredWishlist();
  }

  setWishlist(array) {
    WishlistProduct.setStoredWishlist(array);
    return array.join(this.LOCAL_STORAGE_DELIMITER);
  }

  updateWishlist(handle) {
    let wishlist = this.getWishlist();
    let indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) {
      wishlist.push(handle);
    } else {
      wishlist.splice(indexInWishlist, 1);
    }
    return this.setWishlist(wishlist);
  }

  wishlistContains(handle) {
    return this.getWishlist().indexOf(handle) !== -1;
  }
}

if (!customElements.get("wishlist-item")) {
  customElements.define("wishlist-item", WishlistProduct);
}

document.addEventListener("DOMContentLoaded", function () {
  const grid = document.querySelector("[grid-wishlist]");
  if (grid) {
    setupWishlistGrid(grid);
  }
  // Initialize counters on load
  const count = WishlistProduct.getStoredWishlist().length;
  document.querySelectorAll(".wishlist__count").forEach((el) => {
    el.textContent = count;
  });
});

window.addEventListener("storage", function (e) {
  if (e.key === "shopify-wishlist") {
    const count = WishlistProduct.getStoredWishlist().length;
    document.querySelectorAll(".wishlist__count").forEach((el) => {
      el.textContent = count;
    });
  }
});

var setupWishlistGrid = function (grid) {
  const wishlist = WishlistProduct.getStoredWishlist();
  const wishlistPageEl = document.querySelector(".wishlist-page");

  if (wishlist.length > 0 && wishlistPageEl) {
    wishlistPageEl.classList.add("wishlist_exists");
  }

  if (wishlist.length === 0) {
    if (wishlistPageEl) wishlistPageEl.classList.remove("wishlist_exists");
    return;
  }

  const requests = wishlist.map(function (handle) {
    const productTileTemplateUrl = "/products/" + encodeURIComponent(handle) + "?view=wishlist";
    return fetch(productTileTemplateUrl)
      .then(function (res) {
        if (res.ok) {
          return res.text();
        }
        return "";
      })
      .catch(function () {
        return "";
      });
  });

  Promise.all(requests).then(function (responses) {
    const validCards = [];
    const validHandles = [];
    responses.forEach(function (html, i) {
      if (html && html.trim().length > 0) {
        validCards.push(html);
        validHandles.push(wishlist[i]);
      }
    });

    if (validHandles.length !== wishlist.length) {
      WishlistProduct.setStoredWishlist(validHandles);
    }

    grid.innerHTML = validCards.join("");
    if (validCards.length === 0 && wishlistPageEl) {
      wishlistPageEl.classList.remove("wishlist_exists");
    }
  });
};
